import { auth } from '../../firebase/firebaseSetup';
import AbstractClass from '../abstract/abstractClass';
import { OwnerDocsInterface, editorInterface } from './ownerInterface';

export default class OwnerClass
    extends AbstractClass
    implements OwnerDocsInterface
{
    description: string;
    images?: string[];
    imageFav?: string;
    created: editorInterface;
    updated: editorInterface;
    logged: Record<string, any>;

    constructor(data: Record<string, any>) {
        super(data.id);
        this.logged = auth.currentUser?.toJSON() || {};
        this.description = data.description;
        this.images = data.images;
        this.imageFav = data.imageFav;
        this.created = data.created;
        this.updated = data.updated;
    }

    getDefaultImage(): string {
        return '/defaults/land.jpg';
    }

    getPictures(Image?: string): string[] {
        return (
            (Image && [Image]) ||
            (this.images?.length && this.images) || [this.getDefaultImage()]
        );
    }

    getCreateTime(): number {
        return this.created
            ? new Date(this.created.at).getTime()
            : new Date().getTime();
    }

    getUpdateTime(): number {
        return this.updated
            ? new Date(this.updated.at).getTime()
            : new Date().getTime();
    }

    getImageFav(): string {
        return this.imageFav || this.getPictures()[0];
    }

    toJSON(): Record<string, any> {
        var json = super.toJSON();
        return {
            id: json.id,
            data: {
                created: this.created || {
                    at: Date().toLocaleString(),
                    by: this.logged.uid
                },
                updated: {
                    at: Date().toLocaleString(),
                    by: this.logged.uid
                },
                description: this.description,
                images: this.images,
                imageFav: this.imageFav
            }
        };
    }
}
